module.exports = __webpack_public_path__ + "img/8.63233bf5.png";